module.exports = __webpack_public_path__ + "static/Strukturierte Darstellung aller Beitraege der Online-Beteiligung-4afdc714e92f8d6fd36462b7e84d1f92.pdf";